import { PermissionT } from "../types";

export const loggedActions = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "logged_actions");
  return !!p;
};
export default loggedActions;
